let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cPGW6")).then(() => parcelRequire('5Uxlx'));